import React from 'react'
import CongratulationsContainer from './CongratulationsContainer'

const Congratulations = props => (
  <CongratulationsContainer {...props} data-test="component-congratulations" />
)

export default Congratulations
